<template>
  <div class= "animated fadeIn role-overlay" :class="{disabled: noshow === true}">
    <img src="media/global/role_overlay.png"/>
    <div class="node-icon-holder">
      <img class="node-icon" :src="nodeIconImage"/>
    </div>
    <img class="blue-bar" src="media/page3/blue_box.png"/>
    <div class="title-holder">
      <h5 class="title animated fadeIn">{{(this.$store.state.activeNode === null) ? null : nodePath.nodeTitle}}</h5>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    computed: {
      location () {
        return this.$store.state.scormLMS.location
      },
      noshow () {
        if (this.$store.state.scormLMS.location === 3 ||
            this.$store.state.scormLMS.location === 4 ||
            this.$store.state.scormLMS.location === 5) {
          return false
        } else return true
      },
      nodePath() {
        var activeNodeIndex = (this.$store.state.activeNode === null) ? null : parseInt(this.$store.state.activeNode.slice(-1),10)-1;
        return (this.$store.state.items.activeNode === null) ? null : this.$store.state.items.activityMain.nodeDisplayDetails[activeNodeIndex]
      },
      nodeIconImage() {
        return (this.nodePath == null) ? null : this.nodePath.nodeImage
      }
    },
    methods: {},
    components: {},
    props: ['items']
  }

</script>

<style scoped>
.role-overlay {
  position: absolute;
  top: 45px;
  right: -25px;
  height: 140px;
  width: 200px;
  z-index: 15;
  color: white;
}
.role-overlay.disabled {
  display: none;
  pointer-events: none;
  cursor: default;
}
.node-icon-holder {
  height: 70px;
  width: 70px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  margin-left: 60px;
  margin-top: 5px;
}
.node-icon {
  margin: auto;
  width: 70px;
  -webkit-filter: drop-shadow(2px 2px 2px #222 );
  filter: drop-shadow(2px 2px 2px #222);
}
.blue-bar {
  position: absolute;
  top: 60px;
  left: -10px;
  right: 0;
  bottom: 0;
  margin: auto;
}
.title-holder {
  position: absolute;
  top: 55px;
  left: 40px;
  right: 50px;
  bottom: 0;
  margin: auto;
  height: 30px;
  width: 110px;
}
.title {
  font-weight: normal;
  margin: 2px;
  text-align: center;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// RoleOverlay.vue?0ae70dd4